/* Spielmann · Video-Auslieferung
   ────────────────────────────────────────────────────────────────────
   Liquid gibt über video.sources nur die 1080p-MP4 heraus. Shopifys
   video_tag schreibt sie an rund 35 Stellen im Theme ins Markup.

   Erster Ansatz war hls.js. Für kurze, stumme Loop-Clips ist das die
   falsche Technik: drei Round-Trips vor dem ersten Bild, und der Puffer
   wird bei jedem Loop und jedem Variantenwechsel verworfen und neu
   geholt. Der Hero hat dadurch 6,4 MB gezogen statt 3,4 MB.

   Jetzt: die kleinere Rendition direkt ansprechen. Die Bitraten-Leiter
   bei Shopify ist fest (über alle 499 Videos im Shop geprüft), die URL
   lässt sich deshalb aus der 1080p-URL ableiten. Ein Request, der
   Browser-Cache greift, Loops und Variantenwechsel kosten nichts mehr.
   Schlägt die abgeleitete URL fehl, springt das Element aufs Original. */
(function () {
  'use strict';
  if (window.spVideo) return;

  var LADDER = {
    '2.5': { 720: '1.6', 480: '0.9' },
    '3.3': { 720: '2.1', 480: '1.0' },
    '7.2': { 720: '4.5', 480: '1.5' },
    '4.8': { 720: '3.0', 480: '1.2' }
  };
  var LADDER720 = { '1.6': '0.9', '2.1': '1.0', '4.5': '1.5', '3.0': '1.2' };

  /* ── Eigene Verbindung für Video ──
     99 von 100 Ressourcen der Seite liegen auf www.spielmann.de und
     teilen sich eine HTTP/2-Verbindung: 51 Bilder, 24 Skripte, 21
     Stylesheets — und das Video. Es bekommt dadurch nur einen Bruchteil
     der Bandbreite. cdn.shopify.com liefert dieselben Dateien über eine
     eigene Verbindung; gemessen 89,6 statt 45,9 Mbit/s. */
  function ownHost(url) {
    /* ZURÜCKGENOMMEN 05.08.: Der Wechsel auf cdn.shopify.com führte im
       echten Browser zu einem fehlgeschlagenen Request, der drei Minuten
       offen blieb (11 kB geladen), bevor der Rückfall auf die
       Originalquelle griff. Die Datei ist per curl einwandfrei
       erreichbar, CSP und CORS sind sauber — die Ursache ist also nicht
       geklärt. Solange sie es nicht ist, bleibt alles auf dem Shop-Host. */
    return url || '';
  }
  var RE = /^(.*\/videos\/c\/vp\/([0-9a-f]{32})\/\2\.)(SD-480p|HD-720p|HD-1080p)-([\d.]+)Mbps-(\d+)\.mp4(.*)$/i;

  function rendition(url, maxHeight) {
    var m = RE.exec(url || '');
    if (!m) return '';
    var head = m[1], label = m[3], rate = m[4], suffix = m[5], tail = m[6];
    var cur = label === 'HD-1080p' ? 1080 : (label === 'HD-720p' ? 720 : 480);
    if (cur <= maxHeight) return '';
    var want = maxHeight >= 720 ? 720 : 480;
    var newRate = null, newLabel = null;
    if (cur === 1080 && LADDER[rate]) {
      newRate = LADDER[rate][want];
      newLabel = want === 720 ? 'HD-720p' : 'SD-480p';
    } else if (cur === 720 && want === 480 && LADDER720[rate]) {
      newRate = LADDER720[rate];
      newLabel = 'SD-480p';
    }
    if (!newRate) return '';
    return ownHost(head + newLabel + '-' + newRate + 'Mbps-' + suffix + '.mp4' + tail);
  }

  /* Fertige URL für einen Einbauort: kleinere Rendition + eigener Host.
     Auch dann sinnvoll, wenn die Rendition schon passt — der Host-Wechsel
     allein bringt die doppelte Bandbreite. */
  function url(raw, maxHeight) {
    return rendition(raw, maxHeight || 720) || ownHost(raw);
  }

  /* Nur ein Video streamt gleichzeitig: auf der Startseite haben sich
     Hero und Feature-Video die Bandbreite geteilt, beide ruckelten. */
  var loops = [];
  function registerLoop(v) { if (loops.indexOf(v) === -1) loops.push(v); }
  function pauseLoops(except) {
    loops.forEach(function (v) {
      if (v !== except && !v.paused) { try { v.pause(); } catch (e) {} }
    });
  }
  function resumeLoops() {
    loops.forEach(function (v) {
      if (v.dataset.spWantLoop === '1' && v.paused && v.getAttribute('src')) {
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
    });
  }

  /* ── Stufe an die Leitung koppeln ──
     Gemessen beim Betrieb: rund 1,7 Mbit/s effektiv. Bei 720p sind das
     allein fuer den Start des 360-Videos 1,6 MB und damit 18 Sekunden,
     bevor ueberhaupt ein Bild kommt. In 480p ist dieselbe Datei knapp
     halb so gross. Auf schnellen Leitungen bleibt es bei 720p, die
     Qualitaet geht also nur dort runter, wo sie sonst gar nicht ankommt.
     downlink meldet Chrome in Mbit/s; ohne Angabe bleibt es bei 720p. */
  function capForConnection(wanted) {
    try {
      var n = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!n) return wanted;
      if (n.saveData) return 480;
      var t = n.effectiveType || '';
      if (t === 'slow-2g' || t === '2g' || t === '3g') return 480;
      if (typeof n.downlink === 'number' && n.downlink > 0 && n.downlink < 5) return 480;
    } catch (e) {}
    return wanted;
  }

  function attach(video, src, maxHeight) {
    if (!video || !src) return Promise.resolve();
    video.dataset.spVideoDone = '1';
    var small = rendition(src, capForConnection(maxHeight || 720));
    var use = small || ownHost(src);
    if (small) {
      var onErr = function () {
        video.removeEventListener('error', onErr);
        if ((video.getAttribute('src') || '') === small) {
          video.setAttribute('src', src);   /* zurück auf die Originalquelle */
          try { video.load(); } catch (e) {}
        }
      };
      video.addEventListener('error', onErr);
    }
    video.setAttribute('src', use);
    try { video.load(); } catch (e) {}
    return Promise.resolve();
  }

  function detach(video) {
    if (!video) return;
    try { video.pause(); video.removeAttribute('src'); video.load(); } catch (e) {}
    video.dataset.spVideoDone = '';
  }

  function upgrade(video) {
    if (!video || video.dataset.spAuto === '1') return;
    var url = video.dataset.spSrc || '';
    if (!url) return;
    video.dataset.spAuto = '1';

    var wantsLoop = video.dataset.spAutoplay === '1';
    var box = video.getBoundingClientRect();
    var css = box.height || 0;
    /* 480p ist der Normalfall. Bei diesen Clips (Hochformat, in einer
       Spalte, stumm) ist der Unterschied zu 720p kaum sichtbar, die
       Datei aber knapp drei Mal so groß: das Judith-Video wiegt in
       720p 19,6 MB und in 480p 7,1 MB. 720p nur für großflächige
       Hintergrund-Loops, die den halben Bildschirm füllen. */
    var cap = (wantsLoop && css >= 500) ? 720 : 480;

    var started = false;
    function start(play) {
      if (started) {
        if (play) { var q = video.play(); if (q && q.catch) q.catch(function () {}); }
        return;
      }
      started = true;
      attach(video, url, cap);
      if (play || wantsLoop) {
        if (wantsLoop) video.muted = true;
        var p = video.play(); if (p && p.catch) p.catch(function () {});
      }
    }

    if (wantsLoop) {
      video.dataset.spWantLoop = '1';
      registerLoop(video);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); start(true); } });
        }, { rootMargin: '200px 0px' });
        io.observe(video);
      } else { start(true); }
    } else {
      /* Klick-Video: nichts laden, bis der Nutzer es wirklich will.
         Vorher lud es beim Scrollen vor und nahm dem Hero die Bandbreite. */
      video.addEventListener('play', function () { pauseLoops(video); start(false); });
      video.addEventListener('pause', resumeLoops);
      video.addEventListener('ended', resumeLoops);
      var host = video.closest('.video-card, .t-media, figure, button, [data-vtl-open]');
      (host || video).addEventListener('click', function () { pauseLoops(video); start(true); });
    }
  }

  function scan(root) {
    var l = (root || document).querySelectorAll('video[data-sp-src]');
    for (var i = 0; i < l.length; i++) upgrade(l[i]);
  }

  function autoInit() {
    scan(document);
    if ('MutationObserver' in window) {
      new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) {
          var a = ms[i].addedNodes;
          for (var j = 0; j < a.length; j++) {
            var n = a[j];
            if (n.nodeType !== 1) continue;
            if (n.tagName === 'VIDEO') upgrade(n); else if (n.querySelectorAll) scan(n);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoInit);
  else autoInit();

  window.spVideo = {
    attach: attach, detach: detach, upgrade: upgrade, scan: scan,
    rendition: rendition, url: url, ownHost: ownHost, capForConnection: capForConnection,
    registerLoop: registerLoop, pauseLoops: pauseLoops
  };
})();
